export default "__VITE_ASSET__c68609f0__"